// we do not need it in SPA
const xsrf = {
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
}

const commonHeaders = {
  'X-Ironscales-Client-Type': 'react',
}

function getCookieField(name) {
  const match = document.cookie.match(new RegExp(`(^|;\\s*)(${name})=([^;]*)`))
  return match ? decodeURIComponent(match[3]) : null
}

export function getDefaultHeaders() {
  let defaultHeaders = {
    ...commonHeaders,
  }

  const csrfToken = getCookieField(xsrf.xsrfCookieName)
  if (csrfToken) {
    defaultHeaders = {
      ...defaultHeaders,
      [xsrf.xsrfHeaderName]: csrfToken,
    }
  }

  return defaultHeaders
}
